import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Tooltip from '@omilia/tooltip';
import cn from 'classnames';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';

import { projectType } from 'types';
import TestResultIntent from './components/TestResultIntent';

import './style.scss';

export class WinningIntentsPanel extends Component {
  static propTypes = {
    currentProject: projectType.isRequired,
    deselectAnnotatorResult: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    selectedAnnotatorResult: PropTypes.shape({
      intents: PropTypes.array,
    }),
  };

  state = {
    isExpandedAll: true,
  };

  onSelect = intentId => {
    const { currentProject, deselectAnnotatorResult } = this.props;
    const { slug, account } = currentProject;

    this.props.history.push(`/${account}/${slug}/intents/${intentId}`);

    deselectAnnotatorResult();
  };

  toggle = () => {
    this.setState(prevState => ({
      isExpandedAll: !prevState.isExpandedAll,
    }));
  };

  sortIntents = selectedAnnotatorResult =>
    _orderBy(
      _get(selectedAnnotatorResult, 'intents', []),
      ['score', 'confidence'],
      ['desc', 'desc'],
    );

  render() {
    const { selectedAnnotatorResult, deselectAnnotatorResult } = this.props;
    const { isExpandedAll } = this.state;
    const intents = this.sortIntents(selectedAnnotatorResult);

    // FIXME:
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */

    return (
      <div styleName="panel" onMouseLeave={deselectAnnotatorResult}>
        <div styleName="header">
          <span data-test="winning-intent-panel-title" styleName="title">
            Winning Intent Block ({intents.length})
          </span>
          <Tooltip content={`${isExpandedAll ? 'Collapse' : 'Expand'} All`}>
            <i
              className={cn({
                'icon-triangle-arrow-up': !isExpandedAll,
                'icon-triangle-arrow-down': isExpandedAll,
              })}
              data-test={
                isExpandedAll
                  ? 'collapse-all-results-button'
                  : 'expand-all-results-button'
              }
              styleName="triangle"
              onClick={this.toggle}
            />
          </Tooltip>
          <i
            className="icon-close"
            data-test="close-winning-intent-panel-button"
            styleName="close"
            onClick={deselectAnnotatorResult}
          />
        </div>
        <div data-test="test-results" styleName="content">
          {intents.map(intent => (
            <TestResultIntent
              key={intent.id}
              intent={intent}
              isExpandedAll={isExpandedAll}
              onSelect={this.onSelect}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default withRouter(WinningIntentsPanel);
